























































































import { Component, Prop, Vue } from 'vue-property-decorator';

import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: { ElementBgIcon },
  async created() {
    await Promise.all([this.$pdc.doctor!.getLastPatients()]);
  },
})
export default class HomeWidgets extends Vue {
  @Prop({ required: true }) private totalPatient!: number | null;

  get patients() {
    return this.$pdc.entities!.patients.storedEntity;
  }

  get soles() {
    return this.$pdc.entities!.soles.storedEntity;
  }

  get stations() {
    return this.$pdc.entities!.stations.storedEntity;
  }

  get station() {
    const _s = this.stations.list.filter((x) => x.online);
    if (!_s.length) {
      if (this.stations.list.length) {
        return this.stations.list[0];
      } else {
        return null;
      }
    } else {
      return _s[0];
    }
  }

  get lastPatients() {
    return this.$pdc.doctor!.lastPatients;
  }

  analytics(key: string) {
    // this.$pdc.analytics?.actions.trackSuccess(`Home Widgets New${key}Analysis Click`);
    /*this.$pdc.analytics?.actions.trackSuccess('Widget Clicked', {
      type: key
    });*/
  }

  async goTo(eventName: string, routeParams: any) {
    // Analytics
    // this.$pdc.analytics?.actions.trackSuccess(`Home Widgets ${eventName} Click`);
    this.$pdc.analytics?.actions.trackSuccess('Widget Clicked', {
      type: eventName,
    });

    await this.$router.push(routeParams);
  }
}
